/** `data` de un push: el servidor manda todos sus valores como string. */
export type PushData = Record<string, string | undefined>;

/** Búsqueda precargada que abre el aviso de lugar liberado (lista de espera). */
export interface PushTicketSearch {
  stop: { id: number; name: string; route_id: number; radial_id: number };
  date: string;
  type: string;
  highlightRealtripId: number;
}

export interface PushRoute {
  path: string[];
  ticketSearch?: PushTicketSearch;
}

const ROOT = '/tecservice-transportec';

/**
 * Pantalla que abre un push al tocarlo, según `data.type`. Mismo destino desde la
 * notificación del sistema y desde la notificación local con la que Android presenta
 * un push con el app abierta. La bandeja (notification.page.ts) tiene su propia copia.
 */
export function pushRoute(data: PushData | undefined): PushRoute {
  switch (data?.['type']) {
    case 'ticket_message':
      return { path: [`${ROOT}/wallet/tickets/${data['ticket_id']}`] };
    case 'payment_success':
    case 'ticket_invoice':
      return { path: [`${ROOT}/wallet/transactions`] };
    case 'busticket_reservation':
    case 'busticket_reminder':
    case 'busticket_scanned':
      return data['busticket_id']
        ? { path: [`${ROOT}/tickets/ticket/${data['busticket_id']}`] }
        : { path: [`${ROOT}/tickets`] };
    case 'circuit_completed':
    case 'circuit_unregistered_alight':
      return data['circuit_reservation_id']
        ? { path: [`${ROOT}/circuito/ticket/${data['circuit_reservation_id']}`] }
        : { path: [`${ROOT}/circuito`] };
    case 'busticket_availability':
      if (data['realtrip_id'] && data['stop_id'] && data['date'] && data['route_id'] && data['radial_id']) {
        return {
          path: [`${ROOT}/transportec/search`],
          ticketSearch: {
            stop: {
              id: Number(data['stop_id']),
              name: data['stop_name'] ?? '',
              route_id: Number(data['route_id']),
              radial_id: Number(data['radial_id']),
            },
            date: data['date'] + ' 23:01:00',
            type: data['direction'] ?? 'go',
            highlightRealtripId: Number(data['realtrip_id']),
          },
        };
      }
      return { path: [`${ROOT}/transportec/tickets`] };
    default:
      return { path: [`${ROOT}/wallet/notifications`] };
  }
}
